var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEVentilationDucts = function SvgEVentilationDucts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "336 152.01 26 152.01 38 140 348 140 336 152.01",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 145,
    width: 311,
    height: 2,
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 149,
    width: 311,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 142,
    width: 311,
    height: 1,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "26 152.01 26 96.02 38 96.02 38 140 26 152.01",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 96,
    width: 2,
    height: 51,
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 96,
    width: 1,
    height: 54,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 96,
    width: 1,
    height: 47,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "348 140 348 192 336 192 336 152.01 348 140",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 145,
    width: 2,
    height: 47,
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 142,
    width: 1,
    height: 50,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 149.01,
    width: 1,
    height: 42.99,
    fill: "#787878"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "27 86.02 32 94 37 86.02 34 86.02 34 80 30 80 30 86.02 27 86.02",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.59,76.4c0-.27-.1-.48-.29-.63-.19-.15-.54-.3-1.04-.45-.5-.15-.9-.32-1.2-.5-.57-.36-.85-.82-.85-1.39,0-.5.2-.91.61-1.24.41-.32.94-.49,1.59-.49.43,0,.82.08,1.16.24s.6.39.8.68c.19.29.29.62.29.98h-1.08c0-.32-.1-.58-.31-.76s-.5-.28-.87-.28c-.35,0-.63.08-.82.23-.2.15-.29.36-.29.63,0,.23.1.42.32.57.21.15.56.3,1.04.44.48.14.87.31,1.17.49.29.18.51.39.65.63s.21.52.21.83c0,.52-.2.93-.6,1.24-.4.31-.94.46-1.62.46-.45,0-.86-.08-1.24-.25-.38-.17-.67-.4-.88-.69-.21-.29-.31-.64-.31-1.03h1.08c0,.35.12.63.35.82s.57.29,1,.29c.38,0,.66-.08.85-.23s.28-.35.28-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17,71.78v4.16c0,.66-.21,1.18-.63,1.57-.42.39-.99.58-1.69.58s-1.28-.19-1.7-.57-.63-.91-.63-1.58v-4.15h1.08v4.16c0,.42.11.73.32.95s.52.33.93.33c.83,0,1.25-.44,1.25-1.32v-4.13h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,75.69v2.31h-1.08v-6.22h2.38c.7,0,1.25.18,1.66.54.41.36.61.84.61,1.44s-.2,1.08-.6,1.42-.96.51-1.68.51h-1.29ZM36.41,74.82h1.3c.38,0,.68-.09.88-.27.2-.18.3-.44.3-.78s-.1-.6-.31-.81c-.21-.2-.49-.3-.85-.31h-1.33v2.17Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "337 199.97 342 207.94 347 199.97 344 199.97 344 193.96 340 193.96 340 199.97 337 199.97",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.59,214.34c0-.27-.1-.48-.29-.63-.19-.15-.54-.3-1.04-.45-.5-.15-.9-.32-1.2-.5-.57-.36-.85-.82-.85-1.39,0-.5.2-.91.61-1.24.41-.32.94-.49,1.59-.49.43,0,.82.08,1.16.24s.6.39.8.68c.19.29.29.62.29.98h-1.08c0-.32-.1-.58-.31-.76s-.5-.28-.87-.28c-.35,0-.63.08-.82.23-.2.15-.29.36-.29.63,0,.23.1.42.32.57.21.15.56.3,1.04.44.48.14.87.31,1.17.49.29.18.51.39.65.63s.21.52.21.83c0,.52-.2.93-.6,1.24-.4.31-.94.46-1.62.46-.45,0-.86-.08-1.24-.25-.38-.17-.67-.4-.88-.69-.21-.29-.31-.64-.31-1.03h1.08c0,.35.12.63.35.82s.57.29,1,.29c.38,0,.66-.08.85-.23s.28-.35.28-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.17,209.72v4.16c0,.66-.21,1.18-.63,1.57-.42.39-.99.58-1.69.58s-1.28-.19-1.7-.57-.63-.91-.63-1.58v-4.15h1.08v4.16c0,.42.11.73.32.95s.52.33.93.33c.83,0,1.25-.44,1.25-1.32v-4.13h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.41,213.64v2.31h-1.08v-6.22h2.38c.7,0,1.25.18,1.66.54.41.36.61.84.61,1.44s-.2,1.08-.6,1.42-.96.51-1.68.51h-1.29ZM346.41,212.76h1.3c.38,0,.68-.09.88-.27.2-.18.3-.44.3-.78s-.1-.6-.31-.81c-.21-.2-.49-.3-.85-.31h-1.33v2.17Z"
  })))));
};
export default SvgEVentilationDucts;